export class PhysicalInventoryAlertModel {
    public readonly scheduleDate: string;
    public readonly startTime: string;
    public readonly endTime: string;

    public constructor(public data: OdataPIScheduleModel) {
        this.scheduleDate = data.Date;
        this.startTime = data.StartTime;
        this.endTime = data.EndTime;
    }

    public isModelEmpty(): boolean {
        return this.scheduleDate.length <= 0 && this.startTime.length <= 0 && this.endTime.length <= 0;
    }

    public static fromODataPIScheduleSet(data: OdataPIScheduleModel): PhysicalInventoryAlertModel {
        return new PhysicalInventoryAlertModel(data);
    }

    public static emptyPhysicalInventoryAlertModel(): PhysicalInventoryAlertModel {
        const data: OdataPIScheduleModel = {
            Date: '',
            StartTime: '',
            EndTime: '',
        };
        return new PhysicalInventoryAlertModel(data);
    }
}

export interface OdataPIScheduleModel {
    Date: string;
    StartTime: string;
    EndTime: string;
}
